import request from '@/utils/request';

export default {
    getBrands: async({ state, dispatch, commit }) => {
        if (state.brands.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/admin/brands/all' })
            .then(res => {
                if (res.data) {
                    commit('SET_BRANDS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getEstablishments: async({ state, dispatch, commit }) => {
        if (state.establishments.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/delivery/establishments/all' })
            .then(res => {
                if (res.data) {
                    commit('SET_ESTABLISHMENTS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getOperators: async({ state, dispatch, commit }) => {
        if (state.brands.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/admin/operators' })
            .then(res => {
                if (res.data) {
                    commit('SET_OPERATORS', res.data.map(op => {
                        op.fullText = [op.firstName, op.middleName, op.lastName, op.phone].filter(i => !!i).join(' ');

                        return op;
                    }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getOptions: async({ state, commit, dispatch }) => {
        if (state.brandOptions && state.brandOptions.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/admin/options/public' })
            .then(res => {
                commit('SET_BRAND_OPTIONS', res.data);
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getConfidenceLevels: async({ state, commit, dispatch }) => {
        if (state.deliveryConfidenceLevels && state.deliveryConfidenceLevels.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/delivery/settings/confidenceLevels' })
            .then(res => {
                commit('SET_CONFLEVELS', JSON.parse(res.data.confidenceLevels));
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getDriverCommissions: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: '/admin/driver/commissions/all',
            params
        }).then(res => {
            if (res.data) {
                commit('SET_DRIVER_COMMISSIONS', res.data);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    },

    getDriverCommissionSystems: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/commission-systems/all', params })
            .then(res => {
                if (res.data) {
                    commit('SET_DRIVER_COMMISSION_SYSTEMS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getCompanies: async({ state, dispatch, commit }) => {
        if (state.companies.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/admin/company' })
            .then(res => {
                if (res.data) {
                    commit('SET_COMPANIES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getDistricts: async({ state, dispatch, commit }) => {
        if (state.districts.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/districts' })
            .then(res => {
                if (res.data) {
                    commit('SET_DISTRICS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getOptionClasses: async({ state, dispatch, commit }) => {
        if (state.optionClasses.length > 0) {
            return;
        }

        await request({ method: 'get', url: '/admin/option/classes' })
            .then(res => {
                if (res.data) {
                    commit('SET_OPTION_CLASSES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getCurrentBranch: async ({ state, dispatch, commit }) => {
        if (state.currentBranch) {
            return;
        }

        await request({ method: 'get', url: '/branch/current' })
            .then(res => {
                if (res.data) {
                    commit('SET_CURRENT_BRANCH', {
                        api: res.data,
                        client: process.env.VUE_APP_CURRENT_BRANCH
                    });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    createDriverLike: async ({ dispatch }, data) => {
        await request({ method: 'post', url: `/drivers/${data.driverId}/likes`, data })
            .then(res => {
                if (res.status === 204) {
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
